import React, { Fragment } from "react";

import "@/styles/pages/contat-us/contact-by-whatsapp.scss";
import { Flex } from "antd";
import ButtonComponent from "@/components/button/Button";
import IconWhatsapp from "@/components/icons/IconWhatsapp";
import IconInstagram from "@/components/icons/IconInstagram";
import IconGmail from "@/components/icons/IconGmail";
import { openLinkInNewTab } from "@/helpers";

const ContactByWhatsApp = () => {
  const handleWhatsappClick = () => {
    const phoneNumber = "+447587039853";
    const formattedMessage = `Hi, I'm interested in getting help with the admission process. Could you please provide more details on the services you offer and how I can get started? Thank you!`;

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${formattedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <Fragment>
      <div className="contact-by-whatsapp-wrapper">
        <div className="text-white text-center title-h5-1">Have more questions?</div>
        <div className="message body-b1-2">We'd love to chat! Reach out to us at:</div>
        <Flex gap={"10px"} wrap className="whatsapp-button">
          <ButtonComponent
            varient="success"
            label="Connect on Whatsapp"
            icon={<IconWhatsapp color="#fdfefe" />}
            onClick={handleWhatsappClick}
          />
          <a href="mailto:student@inforens.com" target="_blank" rel="noreferrer">
            <ButtonComponent
              varient="success"
              label="student@inforens.com"
              icon={<IconGmail />}
              onClick={() => {}}
            ></ButtonComponent>
          </a>
          <ButtonComponent
            varient="success"
            label="@inforens_"
            icon={<IconInstagram />}
            onClick={() => openLinkInNewTab("https://www.instagram.com/inforens_/")}
          />
        </Flex>
        <div className="message body-b1-2">Inforens - The Home Of International Students</div>
      </div>
    </Fragment>
  );
};

export default ContactByWhatsApp;
